import React from 'react';
import { Box, Card, Stack, InputLabel, FormControl, NativeSelect, Typography } from '@mui/material';
import ReadingBar from './ReadingBar';
import NonProratedReadingBar from './NonProratedReadingBar';
import ProratedReadingBar from './ProratedReadingBar';
import { useNavigate } from 'react-router-dom';

const SubMeterRow = ({ subMeter, calculatePosition, timelineLength, selection, onSelectionChange }) => {
    const navigate = useNavigate();

    const handleSelectChange = (e) => {
        const selectedValue = parseInt(e.target.value);
        onSelectionChange(selectedValue); // Seçimi ana bileşene bildir
    };

    return (
        <Box sx={{ mb: 2 }}>
            <Card
                variant="outlined"
                sx={{
                    position: 'relative',
                    width: `${timelineLength}px`,
                    backgroundColor: '#f0f0f0',
                    borderRadius: '4px',
                }}
            >
                <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    <InputLabel>
                        {subMeter.name} ({subMeter.kod})
                    </InputLabel>

                    {subMeter.meterReadingAllocationStatus === "INITIAL_MISSING" && (
                        <div style={{ color: 'red', fontSize: '0.9rem' }}>
                            Başlangıç okuması eksik –{" "}
                            <span
                                style={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }}
                                onClick={() => navigate(`/add-meter-reading/${subMeter.mainMeterId}?subMeterId=${subMeter.subMeterId}`)}
                            >
                                okuma gir
                            </span>
                        </div>
                    )}
                    {subMeter.meterReadingAllocationStatus === "FINAL_MISSING" && (
                        <Typography variant="caption" color="warning.main" sx={{ ml: 2 }}>
                            Fatura bitiş tarihinden sonra sayaç okuması yapılmamış
                            <span
                                style={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }}
                                onClick={() => navigate(`/add-meter-reading/${subMeter.mainMeterId}?subMeterId=${subMeter.subMeterId}`)}
                            >
                                okuma gir
                            </span>

                        </Typography>
                    )}


                    {subMeter.meterReadingAllocationStatus === "OK" && (
                        <FormControl>
                            <NativeSelect value={selection} onChange={handleSelectChange}>
                                <option value={0}>Seçiniz</option>
                                <option value={1}>Orantılayarak sonraki faturaya bırak</option>
                                <option value={2}>Bu Fatura kapsamında hesapla</option>
                            </NativeSelect>
                        </FormControl>
                    )}
                </Stack>
            </Card>
            <Stack
                direction="row"
                sx={{
                    position: 'relative',
                    gap: 0.5,
                    alignItems: 'center',
                }}
            >
                {/* Reading Bars */}
                {subMeter.meterReadings?.map((reading) => {
                    return !reading.daysBeyondInvoice || (selection === 0 && reading.daysBeyondInvoice) ? (
                        <ReadingBar
                            key={reading.id}
                            startPosition={calculatePosition(reading.previousReadingTime)}
                            endPosition={calculatePosition(reading.readingTime)}
                            totalConsumption={reading.totalConsumption}
                            prorationType={selection}
                        />
                    ) : selection === 1 ? (
                        <ProratedReadingBar
                            key={reading.id}
                            startPosition={calculatePosition(reading.previousReadingTime)}
                            endPosition={calculatePosition(reading.readingTime)}
                            totalConsumption={reading.totalConsumption}
                            prorationPosition={timelineLength}
                            incConsumption={reading.consumptionWithinInvoice}
                            excConsumption={reading.consumptionBeyondInvoice}
                        />
                    ) : selection === 2 ? (
                        <NonProratedReadingBar
                            key={reading.id}
                            startPosition={calculatePosition(reading.previousReadingTime)}
                            endPosition={calculatePosition(reading.readingTime)}
                            totalConsumption={reading.totalConsumption}
                            prorationPosition={timelineLength}
                            daysLeft={reading.daysBeyondInvoice}
                        />
                    ) : null;
                })}

                {/* Eksik Sayaç Okuma Mesajı */}
                {subMeter.hasMissingMeterReading && (
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'red',
                            ml: 1,
                            whiteSpace: 'nowrap',
                        }}
                    >
                        Eksik Sayaç Okuma
                    </Typography>
                )}
            </Stack>
        </Box>
    );
};

export default SubMeterRow;
